import { Link } from 'react-router-dom'
import { differenceInDays, parseISO, format } from 'date-fns'
import { useUpcomingRefills } from '../hooks/useMedications'

const RefillBadge = ({ refillDate }) => {
  if (!refillDate) return null
  const days = differenceInDays(parseISO(refillDate), new Date())
  if (days < 0)  return <span className="text-xs font-semibold px-2 py-0.5 rounded-full bg-rose-100 text-rose-600">Overdue</span>
  if (days <= 7) return <span className="text-xs font-semibold px-2 py-0.5 rounded-full bg-amber-100 text-amber-700">{days}d</span>
  return <span className="text-xs text-text-muted">{format(parseISO(refillDate), 'MMM d')}</span>
}

export const MedicationRefillsWidget = () => {
  const { data: refills = [], isLoading } = useUpcomingRefills(14)

  if (isLoading || refills.length === 0) return null

  const top = refills.slice(0, 4)

  return (
    <div className="mb-4">
      <div className="flex items-center justify-between mb-2">
        <h2 className="text-xs font-semibold text-text-muted uppercase tracking-wider">Upcoming Refills</h2>
        <Link to="/medications" className="text-xs text-primary font-medium">View all</Link>
      </div>
      <div className="bg-surface rounded-base shadow-card overflow-hidden">
        {top.map((r, i) => (
          <Link
            key={r.id}
            to="/medications"
            className={`flex items-center justify-between px-4 py-3 hover:bg-background transition-colors ${i < top.length - 1 ? 'border-b border-border' : ''}`}
          >
            <div className="min-w-0">
              <p className="text-sm font-semibold text-text-primary truncate">{r.name}</p>
              <p className="text-xs text-text-muted truncate">{r.member_name} · {r.dosage}</p>
            </div>
            <RefillBadge refillDate={r.refill_date} />
          </Link>
        ))}
      </div>
    </div>
  )
}
